"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInitialProduct = void 0;
const getInitialProduct = ({
  initialProductCode,
  products
}) => {
  if (initialProductCode) {
    const initialProduct = products.find(({
      code
    }) => code === initialProductCode);
    const initialProductShade = initialProduct?.shades.find(({
      productCode
    }) => productCode === initialProductCode);
    const productIndex = products.findIndex(({
      code
    }) => code === initialProductCode);
    // istanbul ignore next @preserve -- Not reachable edge case
    const index = productIndex < 0 ? 0 : productIndex;
    return {
      index,
      product: initialProduct,
      shade: initialProductShade
    };
  }
  return {
    index: 0,
    product: products[0],
    shade: products[0]?.shades?.[0]
  };
};
exports.getInitialProduct = getInitialProduct;